module.exports = __webpack_public_path__ + "img/ojpj-slider-img-4.6c0c8b3d.png";